import { ServerVariableElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class ServerVariable extends ServerVariableElement {}
export default ServerVariable;